import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import EmailConfig from './ongletConfigurationBase/EmailConfig';
import ThemeConfig from './ongletConfigurationBase/ThemeConfig';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        minHeight: 500,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        minWidth: "200px",
    },
    customTab: {
        fontWeight: "normal",
        '&:focus': {
            fontWeight: "bold",
        },
        '&:hover': {
            fontWeight: "bold",
        },
    },
}));

const OngletConfigurationBase = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="autres config tabs"
                className={classes.tabs}
            >
                <Tab className={classes.customTab} label="Emails" {...a11yProps(0)} />
                <Tab className={classes.customTab} label="Thème" {...a11yProps(1)} />
                <Tab className={classes.customTab} label="Groupes" {...a11yProps(2)} />
                <Tab className={classes.customTab} label="API" {...a11yProps(3)} />
                <Tab className={classes.customTab} label="Profil" {...a11yProps(4)} />
                <Tab className={classes.customTab} label="Terminologie" {...a11yProps(5)} />
                <Tab className={classes.customTab} label="Autres" {...a11yProps(6)} />
            </Tabs>
            <TabPanel value={value} index={0}>
                <EmailConfig />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ThemeConfig />
            </TabPanel>
            <TabPanel value={value} index={2}>
                C
            </TabPanel>
            <TabPanel value={value} index={3}>
                D
            </TabPanel>
            <TabPanel value={value} index={4}>
                E
            </TabPanel>
            <TabPanel value={value} index={5}>
                F
            </TabPanel>
            <TabPanel value={value} index={6}>
                G
            </TabPanel>
        </div>
    );
};

export default OngletConfigurationBase;